import { RootState } from "@/redux/store";
import { useDeleteFilterVariantsMutation, useGetFilterVariantList } from "@/services";
import { useQueryClient } from "@tanstack/react-query";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "@/components/Toast";

const useLoadVariant = () => {
  const queryClient = useQueryClient();

  const communityData = useSelector((state: RootState) => state.currentData.communityData);
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const selectedVariant = useRef<any>(null);

  const { data: variantList, isLoading: isLoadingVariant } = useGetFilterVariantList({
    communityId: communityData?.communityId,
    queryParams: {
      enabled: !!communityData?.communityId
    }
  });

  const { mutate: deleteInfo, isPending: isDeletePending } =
    useDeleteFilterVariantsMutation({
      onError: (error?: any) => {
        toast.error(
          typeof error?.response?.data?.message === "string"
            ? error?.response?.data?.message
            : "Something went wrong"
        );
        return error?.response?.data?.message;
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["managerial-filter-variant-list"] });
        setOpenDeleteDialog(false);
        toast.success("Variant deleted");
      },
    });

  const onDelete = (row: any) => {
    selectedVariant.current = row;
    setOpenDeleteDialog(true);
  }

  const onDeleteConfirm = () => {
    deleteInfo({ id: selectedVariant.current?.managerialReportFilterVariantId });
  }

  return {
    isLoading: isLoadingVariant,
    variantList: variantList?.data || [],
    isDeletePending,
    onDelete,
    onDeleteConfirm,
    openDeleteDialog,
    setOpenDeleteDialog,
    selectedVariant: selectedVariant.current
  }
};

export default useLoadVariant;